var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "MaterialDateRangePicker",
    {
      attrs: {
        disabled: _vm.disabled,
        name: _vm.name,
        showDropdowns: _vm.showDropdowns,
        clearButton: _vm.clearButton,
        inputClasses: _vm.inputClasses,
        error: _vm.error,
        singleDatePicker: true,
        dateFormat: _vm.dateFormat,
      },
      model: {
        value: _vm.dateRange,
        callback: function ($$v) {
          _vm.dateRange = typeof $$v === "string" ? $$v.trim() : $$v
        },
        expression: "dateRange",
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }